import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useToggleBlockToggle } from 'common/Prose/Toolbar/hooks/useToggleBlockToggle'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/Buttons/Button'
import { ShortcutAwareTooltip } from 'common/Prose/utils/ShortcutAwareTooltip'
import SimpleDropdownStyles from '../SimpleDropdown/SimpleDropdown.module.scss'
import cx from 'classnames'

export const ToggleBlockButton = observer(() => {
  const view = useEditorView()
  const { active, handleClick, disabled } = useToggleBlockToggle(view)

  return (
    <ShortcutAwareTooltip label="Toggle list">
      <Button
        aria-label="Turn into toggle block"
        active={active}
        disabled={disabled}
        onClick={handleClick}
        className={cx(SimpleDropdownStyles.dropdownButton, { [SimpleDropdownStyles.active]: active })}
      >
        <ToolbarIcon name={IconName.ToggleBlock} />
      </Button>
    </ShortcutAwareTooltip>
  )
})
